import { Injectable, signal, computed } from '@angular/core';
import { ChecklistListItemEntity } from '../../domain/entities/checklist-list-item.entity';

@Injectable({ providedIn: 'root' })
export class ChecklistListState {
  private readonly _checklists = signal<ChecklistListItemEntity[]>([]);
  private readonly _checklistsCount = signal<number>(0);
  private readonly _loading = signal(false);
  private readonly _saving = signal(false);
  private readonly _error = signal<string | null>(null);

  // Read-only signals
  public readonly checklists = this._checklists.asReadonly();
  public readonly checklistsCount = this._checklistsCount.asReadonly();
  public readonly loading = this._loading.asReadonly();
  public readonly saving = this._saving.asReadonly();
  public readonly error = this._error.asReadonly();

  // Computed signals
  public readonly hasChecklists = computed(() => this._checklists().length > 0);

  public setChecklists(checklists: ChecklistListItemEntity[]): void {
    this._checklists.set(checklists);
  }

  public setChecklistsCount(count: number): void {
    this._checklistsCount.set(count);
  }

  public setLoading(loading: boolean): void {
    this._loading.set(loading);
  }

  public setError(error: string | null): void {
    this._error.set(error);
    this._loading.set(false);
  }

  public setSaving(saving: boolean): void {
    this._saving.set(saving);
  }

  public updateChecklist(updatedChecklist: ChecklistListItemEntity): void {
    this._checklists.update((current) =>
      current.map((cl) => (cl.id === updatedChecklist.id ? updatedChecklist : cl)),
    );
  }

  public removeChecklist(caseTypeId: string): void {
    this._checklists.update((current) => current.filter((cl) => cl.caseTypeId !== caseTypeId));
  }

  public clearError(): void {
    this._error.set(null);
  }

  public clear(): void {
    this._checklists.set([]);
    this._checklistsCount.set(0);
    this._loading.set(false);
    this._error.set(null);
    this._saving.set(false);
  }
}
